import React from "react"
import TranspondForm from "../TranspondForm"
import { useTranslation, Trans } from "@zestia/gatsby-plugin-react-i18next"

const NewsletterSignup = ({ className = "" }) => {
  const { t } = useTranslation()
  return (
    <div className={`newsletter-signup ${className}`}>
      <div className="row center-xs">
        <div className="mb-6 sm:mb-8 col-xs-12 col-sm-10">
          <h3 className="h4">{t("newsletter.signup.title")}</h3>
        </div>

        <div className="col-xs-12 col-sm-10 col-md-10">
          <TranspondForm
            srcUrl={"https://api.transpond.io/form?am=30494&fid=16040"}
            className=""
            formId={"newsletterSignup"}
          />
          <p className="p--sm">
            <Trans
              i18nKey="newsletter.signup.privacy-policy"
              components={{
                Link: (
                  <a
                    className="text-link text-link--bare"
                    href="/privacy/"
                    title="Read our privacy policy"
                  />
                ),
              }}
            />
          </p>
        </div>
      </div>
    </div>
  )
}

export default NewsletterSignup
